import { Option } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";

import {
  OrderType,
  PerformancePredictionType,
  Incoterm,
  ServiceType,
  OrderModeType,
  OrderStatus,
  QuantityUnitType,
} from "../../util/enums";

const getOrderOptions = () => {
  const { t: translate } = useTranslation();

  const orderStatusOptions: Option[] = [
    { value: OrderStatus.RECEIVED, label: translate("received") },
    { value: OrderStatus.FULFILLED, label: translate("fulfilled") },
    { value: OrderStatus.CANCELLED, label: translate("cancelled") },
    { value: OrderStatus.CLOSED_FOR_RECEIVING, label: translate("closedForReceiving") },
    { value: OrderStatus.CLOSED_FOR_INVOICING, label: translate("closedForInvoicing") },
    { value: OrderStatus.READY_TO_SHIP, label: translate("readyToShip") },
    { value: OrderStatus.LOADED, label: translate("loaded") },
    { value: OrderStatus.ASSIGNED, label: translate("assigned") },
    { value: OrderStatus.CONFIRMED, label: translate("confirmed") },
  ];

  const orderTypes: Option[] = [
    { value: OrderType.PURCHASE, label: translate("purchase") },
    { value: OrderType.SALES, label: translate("salesOrder") },
  ];

  const performancePredictionsTypes: Option[] = [
    {
      value: PerformancePredictionType.AS_PLANNED,
      label: translate("asPlanned"),
    },
    {
      value: PerformancePredictionType.POTENTIAL_DELAY,
      label: translate("potentialDelay"),
    },
    { value: PerformancePredictionType.DELAYED, label: translate("delayed") },
  ];

  const incotermOptions: Option[] = [
    { value: Incoterm.CPT, label: Incoterm.CPT },
    { value: Incoterm.CIP, label: Incoterm.CIP },
    { value: Incoterm.CFR, label: Incoterm.CFR },
    { value: Incoterm.CIF, label: Incoterm.CIF },
    { value: Incoterm.FCA, label: Incoterm.FCA },
    { value: Incoterm.FOB, label: Incoterm.FOB },
  ];

  const serviceTypeOptions: Option[] = [
    { value: ServiceType.FCL, label: ServiceType.FCL },
    { value: ServiceType.LCL, label: ServiceType.LCL },
  ];

  const modeOptions: Option[] = [
    { value: OrderModeType.SEA, label: translate("sea") },
    { value: OrderModeType.AIR, label: translate("air") },
    { value: OrderModeType.ROAD, label: translate("road") },
  ];

  const quantityUnitOptions: Option[] = [
    { value: QuantityUnitType.UNT, label: QuantityUnitType.UNT },
    { value: QuantityUnitType.PKG, label: QuantityUnitType.PKG },
  ];

  return {
    orderTypes,
    performancePredictionsTypes,
    incotermOptions,
    serviceTypeOptions,
    modeOptions,
    orderStatusOptions,
    quantityUnitOptions,
  };
};

export default getOrderOptions;
